/* eslint-disable no-console */
/* eslint-disable no-async-promise-executor */
import { apiRoutes, serverUrl } from '../constants/api-routes';
import { getRequest, postRequest } from '../config/axios-config';

const verifyInboundEnabled = (suffix: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.verifyInboundEnabled}/${suffix}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const checkApplicationExists = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.checkApplicationExists,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const createInboundApplication = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.createInboundApplication,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getInboundBuilderDetails = (suffix: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getInboundBuilderDetails}/${suffix}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProductListInfo = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProductListInfo,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
const getPrimaryInboundFromSubdomain = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getPrimaryInboundFromSubdomain,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getLogPostList = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getLogPostList,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const addLogPost = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.addLogPost,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const addLogStory = (body: object, headers?: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.addLogStory,
        body,
        headers
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

export {
  verifyInboundEnabled,
  checkApplicationExists,
  createInboundApplication,
  getInboundBuilderDetails,
  getPrimaryInboundFromSubdomain,
  getProductListInfo,
  getLogPostList,
  addLogPost,
  addLogStory,
};
